export const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "16px",
    height: 60,
    backgroundColor: "#ffffff",
    transition: "all 0.25s ease",
    "@media (min-width: 1600px)": { height: 72, borderRadius: "20px" },
    "@media (min-width: 2560px)": { height: 90, borderRadius: "24px" },
    "& fieldset": { borderColor: "#d6d9e6" },
    "&:hover fieldset": { borderColor: "#b8bfdc" },
    "&.Mui-focused fieldset": { borderColor: "#0b1f63", borderWidth: "2px" },
  },

  "& .MuiInputLabel-root": {
    fontSize: "15px",
    color: "#9aa3c1",
    "@media (min-width: 1600px)": { fontSize: "1.15rem" },
    "@media (min-width: 2560px)": { fontSize: "2rem" },
  },

  "& .MuiInputLabel-root.Mui-focused": { color: "#0b1f63", fontWeight: 500 },

  "& .MuiInputBase-input": {
    fontSize: "16px",
    color: "#1c2140",
    "@media (min-width: 1600px)": { fontSize: "1.15rem" },
    "@media (min-width: 2560px)": { fontSize: "2rem", padding: "12px 0" },
  },

  /* 1. Ajuste del texto "Ingresa tu DNI..." y mensajes de error */
  "& .MuiFormHelperText-root": {
    fontSize: "0.85rem",
    "@media (min-width: 1600px)": { fontSize: ".75rem" },
    "@media (min-width: 2560px)": { fontSize: "1rem" },
  },

  /* Mantenemos el rojo y negrita si hay error */
  "& .MuiFormHelperText-root.Mui-error": {
    color: "#d32f2f",
    fontWeight: 600,
  },

  /* 2. Ajuste del Ícono del muñequito (PersonOutlineIcon) */
  "& .MuiInputAdornment-root .MuiSvgIcon-root": {
    fontSize: "1.5rem",
    "@media (min-width: 1600px)": { fontSize: "1.15rem" },
    "@media (min-width: 2560px)": { fontSize: "2rem" },
  }
};

export const selectSx = {
  marginTop: "20px",
  "@media (min-width: 1600px)": {
    marginTop: "32px", // Espacio en pantallas grandes
  },
  "@media (min-width: 2560px)": {
    marginTop: "48px", // Espacio en pantallas gigantes
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "16px",
    height: 50,
    backgroundColor: "#ffffff",
    transition: "all 0.25s ease",
    "@media (min-width: 1600px)": { height: "3.5vw", borderRadius: "2rem" },
    "@media (min-width: 2560px)": { height: "3.5vw", borderRadius: "2.5rem" },
    "& fieldset": { borderColor: "#d6d9e6" },
    "&:hover fieldset": { borderColor: "#b8bfdc" },
    "&.Mui-focused fieldset": { borderColor: "#0b1f63", borderWidth: "2px" },
    "& fieldset legend": {
      fontSize: "0.85rem", // Tamaño base
      "@media (min-width: 1600px)": {
        fontSize: "1.15rem",
        marginLeft: "-1.5rem"
      },
      "@media (min-width: 2560px)": {
        fontSize: "1.6rem",
        marginLeft: "-1.8rem"
      }
    },
  },

  "& .MuiInputLabel-root": {
    fontSize: "15px",
    color: "#9aa3c1",
    "@media (min-width: 1600px)": { fontSize: "1.15rem" },
    "@media (min-width: 2560px)": { fontSize: "1.8rem" },
  },

  "& .MuiInputLabel-root.Mui-focused": { color: "#0b1f63", fontWeight: 500 },

  "& .MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    paddingLeft: "18px",
    fontSize: "16px",
    color: "#1c2140",
    "@media (min-width: 1600px)": { fontSize: "1.15rem", paddingLeft: "2rem" },
    "@media (min-width: 2560px)": { fontSize: "2rem", paddingLeft: "2rem" },
  },
};

export const buttonSx = {
  mt: 4,
  height: 56,
  borderRadius: "16px",
  fontSize: "16px",
  fontWeight: 600,
  letterSpacing: "1px",
  textTransform: "uppercase",
  backgroundColor: "#0b1f63",
  boxShadow: "0 12px 30px rgba(11,31,99,0.25)",
  transition: "all 0.25s ease",
  "&:hover": { backgroundColor: "#07174a", boxShadow: "0 15px 35px rgba(11,31,99,0.35)" },
  "&.Mui-disabled": { backgroundColor: "#9aa3c1", color: "#ffffff" },
};

export const dialogPaperSx = {
  p: 2,
  borderRadius: "16px",
  "@media (min-width: 1600px)": { p: 4, borderRadius: "24px" },
  "@media (min-width: 2560px)": { p: 6, borderRadius: "32px" },
};

export const selectIconSx = {
  color: "#0b1f63",
  right: 14,
  fontSize: 28,
  "@media (min-width: 1600px)": { fontSize: 36, right: 20 },
  "@media (min-width: 2560px)": { fontSize: 44, right: 24 },
};

export const menuPaperSx = {
  borderRadius: "12px",
  mt: 1, // margen superior para separarlo un poquito del input
  "& .MuiMenuItem-root": {
    fontSize: "1rem",
    padding: "12px 20px",
    transition: "all 0.2s ease",
    /* Tamaño para pantallas grandes */
    "@media (min-width: 1600px)": {
      fontSize: "1.15rem",
      padding: "16px 24px"
    },
    /* Tamaño para pantallas gigantes */
    "@media (min-width: 2560px)": {
      fontSize: "2rem",
      padding: "20px 32px"
    }
  }
};